module.exports = __webpack_public_path__ + "img/2x.042cd3b.jpg";